/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

function FooterLocation () {
    return (
        <div className="footer-location footer-column">
            <p className='footer-column-title'>Location</p>
            <p>SimpliCity Digital Inc</p>
            <p>{'("SimpliCity CMS")'}</p>
            <address>
                400 - 22 East 5th Ave
                <br />
                Vancouver, BC V5T 1G8
            </address>
        </div>
    );
}

export { FooterLocation };
